import _ from 'lodash'

/**
 * Replace all keys of an object with the result of the function passed
 */
const replaceKeys = <T>(obj: T, func: (str: string) => string): T =>
    JSON.parse(JSON.stringify(obj || null).replace(/"(\w+)":/g, m => `"${func(m)}":`))

/**
 * Replace all keys of an object with their camelCase representation
 */
export const toCamelCase = <T>(obj: T): T => replaceKeys(obj, _.camelCase)

/**
 * Replace all keys of an object with their snake_case representation
 */
export const toSnakeCase = <T>(obj: T): T => replaceKeys(obj, _.snakeCase)
